/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsModeratorControllerGetProductFeaturesQueryResponse,
  TelegramProductsModeratorControllerGetProductFeaturesPathParams,
  TelegramProductsModeratorControllerGetProductFeatures401,
  TelegramProductsModeratorControllerGetProductFeatures404,
} from '../../types/TelegramProductsModeratorControllerGetProductFeatures.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsModeratorGetProductFeatures } from '../../methods/telegramProductsModeratorGetProductFeatures.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsModeratorGetProductFeaturesQueryKey = (
  id: TelegramProductsModeratorControllerGetProductFeaturesPathParams['id'],
) => [{ url: '/api/moderator/telegram/products/features/:id', params: { id: id } }] as const;

export type TelegramProductsModeratorGetProductFeaturesQueryKey = ReturnType<
  typeof telegramProductsModeratorGetProductFeaturesQueryKey
>;

export function telegramProductsModeratorGetProductFeaturesQueryOptions(
  id: TelegramProductsModeratorControllerGetProductFeaturesPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsModeratorGetProductFeaturesQueryKey(id);
  return queryOptions<
    TelegramProductsModeratorControllerGetProductFeaturesQueryResponse,
    ResponseErrorConfig<
      | TelegramProductsModeratorControllerGetProductFeatures401
      | TelegramProductsModeratorControllerGetProductFeatures404
    >,
    TelegramProductsModeratorControllerGetProductFeaturesQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsModeratorGetProductFeatures(id, config);
    },
  });
}

/**
 * {@link /api/moderator/telegram/products/features/:id}
 */
export function useTelegramProductsModeratorGetProductFeatures<
  TData = TelegramProductsModeratorControllerGetProductFeaturesQueryResponse,
  TQueryData = TelegramProductsModeratorControllerGetProductFeaturesQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsModeratorGetProductFeaturesQueryKey,
>(
  id: TelegramProductsModeratorControllerGetProductFeaturesPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsModeratorControllerGetProductFeaturesQueryResponse,
        ResponseErrorConfig<
          | TelegramProductsModeratorControllerGetProductFeatures401
          | TelegramProductsModeratorControllerGetProductFeatures404
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsModeratorGetProductFeaturesQueryKey(id);

  const query = useQuery(
    {
      ...telegramProductsModeratorGetProductFeaturesQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | TelegramProductsModeratorControllerGetProductFeatures401
      | TelegramProductsModeratorControllerGetProductFeatures404
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
